module.exports = "<my-data-display my-data=\"$$area.data.myAreas\"\n  my-nature=\"'area'\"\n  enable-local-search=\"true\"\n  enable-title=\"true\"\n  enable-badges=\"true\"\n  enable-buttons=\"true\"\n  enable-excel=\"true\"\n  enable-links=\"true\"\n  enable-back=\"true\">\n</my-data-display>\n"


//////////////////
// WEBPACK FOOTER
// ./public/javascript/sygem/routing/consult/area/templates/home.html
// module id = 1483
// module chunks = 0